module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "waom-signature"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sigVal),
      expression: "sigVal"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.canSignature),
      expression: "canSignature"
    }],
    ref: "input",
    attrs: {
      "type": "hidden",
      "name": "signature"
    },
    domProps: {
      "value": (_vm.sigVal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sigVal = $event.target.value
      }
    }
  }), _c('img', {
    ref: "img",
    staticClass: "boxed imageBox",
    attrs: {
      "id": "imageBox",
      "src": _vm.sigVal
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16d16c43","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WacomSignature.vue
// module id = 1045
// module chunks = 0